import { createSelector } from '@reduxjs/toolkit';
import modalsSelector from './modals';

const addBlockModalSelector = createSelector(modalsSelector, (modals) => modals.addBlock);

export default addBlockModalSelector;
